/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, ViewChild, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { XdaStringsService } from '../../services/xda-strings.service';
import { UserService } from '../../services/user.service';
import { NgForm } from '@angular/forms';
import { ForgotPasswordComponent } from '../accounts/forgot-password.component';
import { TosUpdateModalComponent } from './tos-update-modal.component';
import { AccountService } from '../../services/account.service';

@Component({
  selector: 'login-modal-component',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.less'],
  standalone: false,
})
export class LoginModalComponent implements OnInit {
  model: any = {};
  loginFailed: string;
  attemptingLogin: boolean;
  displayErrors: boolean;
  emailPlaceholder: string;
  passwordPlaceholder: string;
  allowCreateAccount: boolean;
  @ViewChild('f', { static: true }) public f: NgForm;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private xdaStringsService: XdaStringsService,
    private accountService: AccountService,
  ) {}

  ngOnInit() {
    this.f.valueChanges?.subscribe(() => (this.displayErrors = false));
    this.emailPlaceholder = this.xdaStringsService.strings['SDE_EMAIL2'];
    this.passwordPlaceholder = this.xdaStringsService.strings['SDE_PASSWORD'];
    this.allowCreateAccount = true;
    this.attemptingLogin = false;
  }

  createAccount() {
    const agBaseUrl = this.xdaStringsService.strings['AGBASEURL'];
    const appId = this.xdaStringsService.strings['APPID'];
    const url = `${agBaseUrl}#!/create-account?appId=${appId}`;
    window.location.href = url;

    this.activeModal.close();
  }

  forgotPassword() {
    this.modalService.open(ForgotPasswordComponent, {
      windowClass: 'xrx-modal',
    });
  }

  async login() {
    this.attemptingLogin = true;
    this.loginFailed = '';
    if (this.f.invalid) {
      this.displayErrors = true;
      this.attemptingLogin = false;
      return;
    }

    const user = await this.userService
      .login(this.model.userEmail, this.model.userPassword)
      .catch((err) => {
        this.displayLoginError(err);
      });

    this.attemptingLogin = false;
    if (user) {
      this.activeModal.close();
    }
  }

  displayLoginError(err: any) {
    this.displayErrors = true;
    this.loginFailed = this.userService.getLoginError(err.error);
    if (err.error === 'invalid_tos') {
      this.accountService.getNeededTos(this.model.userEmail).subscribe(
        (result: any) => {
          if (result.length) {
            const modalRef = this.modalService.open(TosUpdateModalComponent, {
              windowClass: 'xrx-modal',
              size: 'lg',
            });
            modalRef.componentInstance.email = this.model.userEmail;
            modalRef.componentInstance.neededTos = result;
            modalRef.result.then(() => {
              this.login();
            });
          }
        },
        (err) => {
          console.error('getNeededTos -- Error', err);
        },
      );
    } else if (err.error === 'eula_not_accepted') {
      const modalRef = this.modalService.open(TosUpdateModalComponent, {
        windowClass: 'xrx-modal',
        size: 'lg',
      });
      modalRef.componentInstance.userId = err.errorDescription;
      modalRef.componentInstance.neededTos = err.error;
      modalRef.result.then(() => {
        this.login();
      });
    }
  }
}
